module.exports = __webpack_public_path__ + "static/media/zakaz.9fcbfb90.svg";